(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/widget-area/assets/javascripts/widget-area-wrapper.js') >= 0) return;  svs.modules.push('/components/core/widget-area/assets/javascripts/widget-area-wrapper.js'); 
var svs = svs || {};

(function(svs, $) {
  'use strict';

  svs.core = svs.core || {};
  svs.widget = svs.widget || {};
  svs.core.widget_area = svs.core.widget_area || {};

  function widgetAttach(name, widgetPartialsExist) {
    return function() {
      var widgets = svs.widgets.data[name],
        widgetContainer = $('#' + name);

      if (Array.isArray(widgets)) {
        if (widgetPartialsExist) {
          svs.core.widget_area.init(name);
        } else {
          var html = widgetPartialsToHTML(widgets);
          widgetContainer.html(html);
        }
        widgetContainer.trigger('widgetAttached');
      }
    };
  }

  function hasWidgetPartials(widgets) {
    for (var i = 0; i < widgets.length; i++) {
      if (Handlebars.partials[widgets[i].partial]) {
        return true;
      }
    }
    return false;
  }

  function widgetPartialsToHTML(widgets) {
    var html = '';

    for (var i = 0; i < widgets.length; i++) {
      if (Handlebars.partials[widgets[i].partial]) {
        svs.core.data.currentWidget = widgets[i].data;
        svs.core.data.currentWidget.index = i;
        html +=
          '<div class="widget">' +
          Handlebars.partials[widgets[i].partial](svs.core.data) +
          '</div>';
        delete svs.core.data.currentWidget;
      } else {
        html += '<div class="widget"></div>';
      }
    }
    return html;
  }

  svs.core.widget_area.widgetAttach = widgetAttach;
  svs.core.widget_area.hasWidgetPartials = hasWidgetPartials;
  svs.core.widget_area.widgetPartialsToHTML = widgetPartialsToHTML;
})(svs, $);

 })(window);